import React from "react";

import { trpc } from "@blis/trpc/react";

import { Input, TextField } from "@/components/ui/field";
import { Form } from "@/components/ui/form";
import { mutationResponse } from "@/utils/trpc";
import { useView } from "./ViewProvider";

export function UpdateViewForm({ onUpdate }: { onUpdate?: () => void }) {
  const { view, filters, settings, setIsEditingLoading } = useView();
  const [name, setName] = React.useState(view.name);

  const updateView = trpc.accession.views.update.useMutation(
    mutationResponse({
      errorTitle: "Failed to update view",
      successMessage: "View updated",
      onSuccess: () => {
        onUpdate?.();
        setIsEditingLoading(false);
      },
      onError: () => {
        setIsEditingLoading(false);
      },
    }),
  );

  React.useEffect(() => {
    setName(view.name);
  }, [view.name]);

  return (
    <Form
      id="view-edit"
      onSubmit={(e) => {
        e.preventDefault();
        setIsEditingLoading(true);
        updateView.mutateAsync({
          id: view.id,
          name,
          filters,
          display: settings.display,
          limit: settings.limit,
        });
      }}
    >
      <TextField
        isRequired
        aria-label="View Name"
        value={name}
        onChange={setName}
      >
        <Input placeholder="Enter view name" />
      </TextField>
    </Form>
  );
}
